exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "table[data-v-e7a8ba44]{margin-bottom:1em}button[data-v-e7a8ba44]{font-size:150%;border:2px solid rgba(0,0,0,0)}button[data-v-e7a8ba44]:focus{background-color:#ddd;border:2px solid #f80}select[data-v-e7a8ba44]{border:1px solid #666;border-radius:0;padding:inherit;width:100%}.error[data-v-e7a8ba44]{margin-bottom:10px}", ""]);

